/**
 * @generated SignedSource<<90a910d787eb779448487dcadaf42b4c>>
 * @relayHash d0e9dccd8b1f990b419ac7ffcb3fef93
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6e4642756211b01e7d6c40b05adaaa396b61e0ac624bcd41274d3e1cdfd3334c

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type peopleEntityInlineListRelayQuery$variables = {
  accountIds: ReadonlyArray<string>;
  requestingUserId: string;
  tenantId: string;
};
export type peopleEntityInlineListRelayQuery$data = {
  readonly knowledgeDiscovery: {
    readonly " $fragmentSpreads": FragmentRefs<"UserInlinePreviewListRelay_knowledgeDiscovery">;
  } | null | undefined;
};
export type peopleEntityInlineListRelayQuery = {
  response: peopleEntityInlineListRelayQuery$data;
  variables: peopleEntityInlineListRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "requestingUserId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tenantId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountIds",
    "variableName": "accountIds"
  },
  {
    "kind": "Variable",
    "name": "requestingUserId",
    "variableName": "requestingUserId"
  },
  {
    "kind": "Variable",
    "name": "tenantId",
    "variableName": "tenantId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "peopleEntityInlineListRelayQuery",
    "selections": [
      {
        "concreteType": "KnowledgeDiscoveryQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeDiscovery",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "UserInlinePreviewListRelay_knowledgeDiscovery"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "peopleEntityInlineListRelayQuery",
    "selections": [
      {
        "concreteType": "KnowledgeDiscoveryQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeDiscovery",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "searchUsersV2",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeDiscoverySearchUserCard",
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "avatarUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "title"
                      },
                      {
                        "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                        "kind": "LinkedField",
                        "name": "thirdPartyIntegrations",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "externalId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "integrationId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "product"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "KnowledgeDiscoverySearchUsers"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6e4642756211b01e7d6c40b05adaaa396b61e0ac624bcd41274d3e1cdfd3334c",
    "metadata": {},
    "name": "peopleEntityInlineListRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "999f7c00a6e3493567cd2d047288ecb0";

export default node;
